import {Grid, SvgIcon} from "@mui/material";
import TextField from "@mui/material/TextField";
import * as React from "react";


const TrackFields = ({artist, title, onDelete, onChange, artistName, trackName})=>{
    return (
        <Grid
            container
            rowSpacing={2}
            columnSpacing={1}
            justifyContent="flex-end"
            sx={{marginBottom: 4}}
        >
            <Grid item flex={1} display={"flex"}>
                <TextField
                    style={{
                        flex: 1
                    }}
                    className="login__page__item"
                    label="Исполнитель"
                    variant="outlined"
                    color="secondary"
                    name={artistName || 'artist'}
                    value={artist}
                    onChange={onChange}
                />
            </Grid>
            <Grid item flex={1} display={"flex"}>
                <TextField
                    style={{
                        flex: 1
                    }}
                    className="login__page__item"
                    label="Трек"
                    variant="outlined"
                    color="secondary"
                    name={trackName || 'title'}
                    value={title}
                    onChange={onChange}
                />
            </Grid>
            <Grid item>
                <SvgIcon onClick={onDelete}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                        <path d="M0 0h24v24H0V0z" fill="none"/>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>
                    </svg>
                </SvgIcon>
            </Grid>
        </Grid>
    )
}

export default TrackFields;